import { Card } from '@/components/ui/card';
import type { SubscriptionStats as ISubscriptionStats } from '@/types/subscriptions';

interface SubscriptionStatsProps {
  stats: ISubscriptionStats;
}

export const SubscriptionStats: React.FC<SubscriptionStatsProps> = ({ stats }) => {
  const formatCurrency = (amount: number): string => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    }).format(amount);
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
      {/* Active Subscriptions */}
      <Card className="p-5 bg-white shadow-sm border border-gray-200 rounded-lg">
        <div className="space-y-1">
          <p className="text-sm font-medium text-gray-600">Active Subscriptions</p>
          <p className="text-3xl font-semibold text-gray-900">
            {stats.active_subscriptions}
          </p>
        </div>
      </Card>

      {/* Active Services */}
      <Card className="p-5 bg-white shadow-sm border border-gray-200 rounded-lg">
        <div className="space-y-1">
          <p className="text-sm font-medium text-gray-600">Active Services</p>
          <p className="text-3xl font-semibold text-gray-900">
            {stats.active_services}
          </p>
        </div>
      </Card>

      {/* Total Monthly Cost */}
      <Card className="p-5 bg-white shadow-sm border border-gray-200 rounded-lg">
        <div className="space-y-1">
          <p className="text-sm font-medium text-gray-600">Total Monthly Cost</p>
          <p className="text-3xl font-semibold text-gray-900">
            {formatCurrency(stats.total_monthly_cost)}
          </p>
        </div>
      </Card>
    </div>
  );
};
